import { useEffect as a } from "react";
const p = ({ currentEnv: e, allowedEnvs: s }) => (a(() => {
  if (s.includes(e)) {
    const t = document.createElement("script");
    t.type = "text/javascript", t.async = !0, t.innerHTML = `
        (function(d,u,ac){
          var s=d.createElement('script');
          s.type='text/javascript';
          s.src='https://a.omappapi.com/app/js/api.min.js';
          s.async=true;
          s.dataset.user=u;
          s.dataset.account=ac;
          d.getElementsByTagName('head')[0].appendChild(s);
        })(document,27375,2863);
      `, document.body.appendChild(t);
  }
}, [e, s]), null);
export {
  p as OptinMonsterScript
};
